

const HireCompanyIcon = (props: INavIcon) => {
    const fillColor = props.light ? '#FFFFFF' : '#2F3454';
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill={fillColor}>
            <path d="M19.4381 5.42141L14.2681 2.43141C13.2781 1.86141 11.7281 1.86141 10.7381 2.43141L5.51813 5.44141C3.44813 6.84141 3.32812 7.05141 3.32812 9.28141V14.7114C3.32812 16.9414 3.44813 17.1614 5.55813 18.5814L10.7281 21.5714C11.2281 21.8614 11.8681 22.0014 12.4981 22.0014C13.1281 22.0014 13.7681 21.8614 14.2581 21.5714L19.4781 18.5614C21.5481 17.1614 21.6681 16.9514 21.6681 14.7214V9.28141C21.6681 7.05141 21.5481 6.84141 19.4381 5.42141ZM12.4981 15.2514C10.7081 15.2514 9.24813 13.7914 9.24813 12.0014C9.24813 10.2114 10.7081 8.75141 12.4981 8.75141C14.2881 8.75141 15.7481 10.2114 15.7481 12.0014C15.7481 13.7914 14.2881 15.2514 12.4981 15.2514Z" />
        </svg>
    );
};

export default HireCompanyIcon;







